import intl from 'react-intl-universal';
import { tailwindOverride, TableHead } from '@getsynapse/design-system';
import { COLUMN_WIDTHS } from './constants';

const tableHeaderCellsStyles = (className?: string) =>
  tailwindOverride('py-3 px-4', className);

const MembersTableHeader = () => {
  const headCells = [
    {
      content: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.HEADER_COLUMNS.NAME'
      ),
      className: tableHeaderCellsStyles('min-w-0'),
      style: { width: COLUMN_WIDTHS.name },
    },
    {
      content: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.HEADER_COLUMNS.JOB_TITLE'
      ),
      className: tableHeaderCellsStyles('min-w-0'),
      style: { width: COLUMN_WIDTHS.jobTitle },
    },
    {
      content: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.HEADER_COLUMNS.EMPLOYMENT_TYPE'
      ),
      className: tableHeaderCellsStyles('min-w-0'),
      style: { width: COLUMN_WIDTHS.employmentType },
    },
    {
      content: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.HEADER_COLUMNS.LOCATION'
      ),
      className: tableHeaderCellsStyles('min-w-0'),
      style: { width: COLUMN_WIDTHS.location },
    },
    {
      content: intl.get(
        'ORG_SETTINGS_PAGE.LEARNING_TEAM_DETAILS_PAGE.MEMBERS_TABLE.HEADER_COLUMNS.ACCOUNT_STATUS'
      ),
      className: tableHeaderCellsStyles('min-w-0'),
      style: { width: COLUMN_WIDTHS.accountStatus },
    },
    {
      content: '',
      style: {
        width: COLUMN_WIDTHS.actions,
      },
    },
  ];

  return <TableHead headCells={headCells} />;
};

export default MembersTableHeader;
